import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import StudentBasicInfo from './StudentBasicInfo';
import StudentAdministrativeInfo from './StudentAdministrativeInfo';
import StudentParentsInfo from './StudentParentsInfo';
import '../../styles/student-profile.scss';

class StudentProfile extends Component {
  profileContent() {
    const { view, student } = this.props;

    switch (view) {
      case 'basica':
        return <StudentBasicInfo student={student} />;
      case 'administrativa':
        return <StudentAdministrativeInfo student={student} />;
      case 'padres':
        return <StudentParentsInfo parents={student.parents} />;
      default:
        return <StudentBasicInfo student={student} />;
    }
  }

  render() {
    const { student } = this.props;

    return (
      <div id="student-profile">
        <h4>{student.firstName} {student.lastName}</h4>
        { !_.isEmpty(student) && this.profileContent() }
      </div>
    );
  }
}

const { object, string } = PropTypes;

StudentProfile.propTypes = {
  student: object.isRequired,
  view: string
};

export default StudentProfile;



// WEBPACK FOOTER //
// ./src/components/student/StudentProfile.js